import { render } from "./ListFlip.vue?vue&type=template&id=4f821e25&scoped=true"
import script from "./ListFlip.vue?vue&type=script&lang=js"
export * from "./ListFlip.vue?vue&type=script&lang=js"

import "./ListFlip.vue?vue&type=style&index=0&id=4f821e25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f821e25"]])

export default __exports__